import React from "react";

interface ErrorTextProps {
  styleClass?: string;
  children: React.ReactNode;
}

function ErrorText({ styleClass, children }: ErrorTextProps) {
  return <p className={styleClass}>{children}</p>;
}

export default ErrorText;
